import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { updateRelationshipErrorMessage } from './useUpdateRelationship.utils';
const loaderName = 'updateRelationship';
export function useUpdateRelationship() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: errorTexts } = useLocaleKeys('errors');
    const { startLoader, stopLoader, showErrorToast, showSuccessToast } = useOverlayContext();
    return async function updateRelationship(param) {
        let { id, version, changes, onSuccess } = param;
        startLoader(loaderName);
        const updateResult = await handleRequest(api.relationship.update(id, {
            version,
            changes
        }));
        if (!updateResult.success) {
            showErrorToast(updateRelationshipErrorMessage(updateResult.error, errorTexts), 'edit-agr-error');
            return stopLoader(loaderName);
        }
        onSuccess && await onSuccess();
        showSuccessToast(commonTexts.toasts.changesSavedSuccessfully(), 'edit-agr-success');
        stopLoader(loaderName);
    };
}
